<div class="manage-groups-container">

 <h1 class="move-device-group-heading">Manage Groups</h1>
 <div *ngIf="showErrors" style="margin-top: 0px;" class="alert valign-children-middle" id="error-main-container">
  <div class="alert-error" role="img" aria-label="Error" aria-hidden="true">
      <i class="icon-badgealert"></i>
  </div>
  <div>
      <h2>Error</h2>
      <p>Something went wrong. Please try to edit group name again.</p>
      <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
  </div>
</div>

<!-- Group delete error -->

<div *ngIf="deleteGroupError" style="margin-top: 0px;" class="alert valign-children-middle" id="error-main-container">
  <div class="alert-error" role="img" aria-label="Error" aria-hidden="true">
      <i class="icon-badgealert"></i>
  </div>
  <div>
      <h2>Error</h2>
      <p>Something went wrong. Please try to delete the group again.</p>
      <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
  </div>
</div>

<!--duplicate group name-->
<div *ngIf="showDuplicateErrors" style="margin-top: 0px;" class="alert valign-children-middle" id="error-main-container">
  <div class="alert-error" role="img" aria-label="Error" aria-hidden="true">
      <i class="icon-badgealert"></i>
  </div>
  <div>
      <h2>Error</h2>
      <p>This group name already exists.</p>
      <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
  </div>
</div>

 <div *ngIf="formSuccessGrp" id="success-main-container">
  <div class="manage-group-success-banner" id="success-container">
    <div class="alert valign-children-middle" id="alert-success-container">
      <div class="alert-success">
        <i class="icon-approval" aria-hidden="true"></i>
      </div>
      <div id="success-message-container">
        <h2 tabindex="-1" id="success-heading">Group was successfully renamed.</h2>
        <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
      </div>
    </div>
  </div>
</div>  

<div *ngIf="deleteGroupSuccess" id="success-main-container">
  <div class="manage-group-success-banner" id="success-container">
    <div class="alert valign-children-middle" id="alert-success-container">
      <div class="alert-success">
        <i class="icon-approval" aria-hidden="true"></i>
      </div>
      <div id="success-message-container">
        <h2 tabindex="-1" id="success-heading">Group was successfully deleted. Any devices in the group have been moved to Default Group.</h2>
        <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
      </div>
    </div>
  </div>
</div>  

 <p class="move-device-group-subheading">Edit the group name or remove your groups from the program. The Default Group cannot be edited or removed.</p>

 <hr id="lineStyle">

 <p class="move-device-group-note">Note:&nbsp;In order to create a new group, devices must be moved. <a class="move-device-group-link" style="cursor: pointer;" (click)="navigateGroupingDevices()">Move devices to a group</a> </p>


 <div>
  <div class="grid-table" cellspacing="0">
   <table class="table">
    <tr>
    <th class="first-col">Group Name</th>
    <th class="second-col">Devices</th>
    <th class="third-col">Actions</th>
   </tr>
    <tr *ngFor="let group of groupArray">
     <td class="first-col-content">{{group.groupName}}</td>
     <td class="second-col-content">{{group.totalNumberOfDevices}}</td>
     <td class="third-col-content"><a href="javascript:void(0)" *ngIf="group.groupName!=='Default Group' " (click)="onEditClick(group.groupName)"><img  src="/assets/img/group-edit.png" alt="edit" /></a> &nbsp;&nbsp;&nbsp; <a href="javascript:void(0)" *ngIf="group.groupName!=='Default Group' " (click)="onDeleteClick(group.groupName)"><img src="/assets/img/group-remove.png" alt="remove" /></a></td>
    </tr>
   </table>
  </div>
 </div>



<!--edit modal popup-->
<div *ngIf='showMangeGrpEditPopup'>
    <app-modal [showModal]="showMangeGrpEditPopup" [modalClass]="modalClass">
      <app-managegroupedit-modal [modalPopupObject]='manageGrpEditModal' [triggerElement]='eventEmit' (modalOutput)="closeMangeGrpEditPopup($event)">
      </app-managegroupedit-modal>
    </app-modal>
  </div>
</div>

<!-- Group Remove confirmation modal -->
<div *ngIf='showGroupRemoveConfirmPopup'>
  <app-modal [showModal]="showGroupRemoveConfirmPopup" [modalClass]="modalClass">
    <app-manage-grp-remove-confirm-modal (closeModal)="closeMangeGrpRemovePopup($event)" (deleteGroupAction)="loadManageGroups($event)" [deleteData]="deleteData">
    </app-manage-grp-remove-confirm-modal>
  </app-modal>
</div>